export const locationProfileQuery = `query getMyLocationProfile ($locationId: ID!, $viewerCompanyId: ID!) {
      locationProfile  (id: $locationId) {
        companyName
        locationName
        id
        companyId
        isMarketingReady
        name
        coverImageUrl
        marketSegments
        companyTypes
        website
        phone
        productType
        amenities
        locationId
        roomCount
        isProductMarketingReady
        profileImageUrl
        imageUrls
        type
        description
        rating {
          value
          type
        }
        address {
          addressOne
          addressTwo
          city
          state
          country
          postalCode
          formattedAddress
        }
        connectionInfo (viewerCompanyId: $viewerCompanyId) {
          shouldShowContactInfo
          status
          lastSent
          id
          isSender
        }
        contacts {
          firstName
          lastName
          name
          type
          phone
          fax
          email
        }
        groups {
          _id
          tag
          items
        }
        products (viewerCompanyId: $viewerCompanyId) {
          name
          id
          images
          isMarketingReady
        }
      }
    }`.replace(/ +(?= )/g, '');


// WEBPACK FOOTER //
// ./src/app/stores/company/location/location-graphql-query.js